import type { FieldSelection } from '#layers/data-model/types/field-selection';

/** Materialize SDK defaults so an empty include survives bracket-notation serialization. */
export function resolveFieldSelectionDefaults(selection: FieldSelection): FieldSelection {
	const result: FieldSelection = {
		...selection,
		fields: selection.fields ?? ['*'],
	};

	if (selection.include) {
		const includes = Object.entries(selection.include).map(([name, query]) => [
			name,
			resolveFieldSelectionDefaults(query),
		]);

		result.include = Object.fromEntries(includes);
	}

	return result;
}
